import { HttpService } from '@/common/services/http.service';

const FeatureService = {
  PAGE_API_HOST: process.env.VUE_APP_ADMIN_HOST,

  getFeatures() {
    return HttpService.httpGet(`${this.PAGE_API_HOST}/api/features`);
  }
};

export default FeatureService;
